

import React from 'react';
import { Box, Text, Group, Title } from '@mantine/core';
import { IconChevronRight, IconFileText } from '@tabler/icons-react';


const StrategicPlanDiagram = () => {
  return (
    <Box className="strategic-plan">
      <style>
        {`
          .strategic-plan .section {
            border-radius: 8px;
            padding: 4px 20px 2px 15px;
            margin-left: 5px;
            transition: all 0.3s ease;
          }

          .strategic-plan .plan-section {
            border-left: 2px solid #565290;
            border-top: 2px solid #565290;
          }

          .strategic-plan .objective-section {
            border-left: 2px solid #8a4a97;
            border-top: 2px solid #8a4a97;
          }

          .strategic-plan .criteria-section {
            border-left: 2px solid #bf3789;
            border-top: 2px solid #bf3789;
          }

          .strategic-plan .kpi-section {
            border-left: 2px solid #e72166;
            border-top: 2px solid #e72166;
          }

          /* Plan section hover */
          .strategic-plan .plan-section:hover {
            background-color: #565290;
          }
          
          .strategic-plan .plan-section:hover > .section-title {
            color: white;
          }

          .strategic-plan .plan-section:hover > .objective-section {
            background-color: #8a4a97;
          }

          .strategic-plan .plan-section:hover > .objective-section > .section-title {
            color: white;
          }

          .strategic-plan .plan-section:hover > .objective-section > .criteria-section {
            background-color: #bf3789;
          }

          .strategic-plan .plan-section:hover > .objective-section > .criteria-section > .section-title {
            color: white;
          }

          .strategic-plan .plan-section:hover > .objective-section > .criteria-section > .kpi-section {
            background-color: #e72166;
          }

          .strategic-plan .plan-section:hover > .objective-section > .criteria-section > .kpi-section > * {
            color: white;
          }

          /* Objective section hover */
          .strategic-plan .objective-section:hover {
            background-color: #8a4a97;
          }

          .strategic-plan .objective-section:hover > .section-title {
            color: white;
          }

          .strategic-plan .objective-section:hover > .criteria-section {
            background-color: #bf3789;
          }

          .strategic-plan .objective-section:hover > .criteria-section > .section-title {
            color: white;
          }

          .strategic-plan .objective-section:hover > .criteria-section > .kpi-section {
            background-color: #e72166;
          }

          .strategic-plan .objective-section:hover > .criteria-section > .kpi-section > * {
            color: white;
          }

          /* Criteria section hover */
          .strategic-plan .criteria-section:hover {
            background-color: #bf3789;
          }

          .strategic-plan .criteria-section:hover > .section-title {
            color: white;
          }

          .strategic-plan .criteria-section:hover > .kpi-section {
            background-color: #e72166;
          }

          .strategic-plan .criteria-section:hover > .kpi-section > * {
            color: white;
          }

          /* KPI section hover */
          .strategic-plan .kpi-section:hover {
            background-color: #e72166;
          }

          .strategic-plan .kpi-section:hover > * {
            color: white;
          }

          .strategic-plan .evidence {
            display: flex;
            align-items: center;
            gap: 10px;
            padding: 4px 0;
            color: #666;
          }

          .strategic-plan .section-title {
            font-weight: 600;
            margin-bottom: 8px;
            margin-top: 6px;
            display: flex;
            align-items: center;
            gap: 6px;
          }
        `}
      </style>

      <Box sx={{ maxWidth: '600px', padding: '15px', fontSize: '14px' }}>
        <Box>
          <Text fw={600} size='md' mb={'0.5rem'}>Plan Estratégico</Text>
          <Box className="section plan-section">
            <Text className="section-title" size='sm'>
              <IconChevronRight size={16} /> Objetivo 1
            </Text>
            <Box className="section objective-section">
              <Text className="section-title" size='sm'>
                <IconChevronRight size={16} /> Criterio 1
              </Text>
              <Box className="section criteria-section">
                <Text className="section-title" size='sm'>
                  <IconChevronRight size={16} /> KPI 1
                </Text>
                <Box className="section kpi-section">
                  <Group spacing="xs" className="evidence" wrap='nowrap'>
                    <IconFileText size={16} />
                    <Text size='sm'>Evidencia 1</Text>
                  </Group>
                  <Group spacing="xs" className="evidence" wrap='nowrap'>
                    <IconFileText size={16} />
                    <Text size='sm'>Evidencia 2</Text>
                  </Group>
                </Box>
                <Text className="section-title" size='sm'>
                  <IconChevronRight size={16} /> KPI...
                </Text>
              </Box>
              <Text className="section-title" size='sm'>
                <IconChevronRight size={16} /> Criterio...
              </Text>
            </Box>
            <Text className="section-title" size='sm'>
              <IconChevronRight size={16} /> Objetivo...
            </Text>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default StrategicPlanDiagram;
